module.exports = __webpack_public_path__ + "static/07-2df7e2efdf4f9356ebc8e8b3714a57a7.jpg";